<div class="related-panel">
  <p class="related-empty" *ngIf="!customerId">
    Salve o cliente para listar as cobranças.
  </p>

  <ng-container *ngIf="customerId">
    <p class="related-empty" *ngIf="loading">Carregando cobranças...</p>
    <p class="related-empty" *ngIf="!loading && rows.length === 0">
      Nenhuma cobrança encontrada para este cliente.
    </p>

    <table mat-table [dataSource]="rows" *ngIf="!loading && rows.length" class="related-table">
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>DESCRIÇÃO</th>
        <td mat-cell *matCellDef="let row">{{ row.description }}</td>
      </ng-container>
      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef>VALOR</th>
        <td mat-cell *matCellDef="let row">{{ row.value }}</td>
      </ng-container>
      <ng-container matColumnDef="dueDate">
        <th mat-header-cell *matHeaderCellDef>VENCIMENTO</th>
        <td mat-cell *matCellDef="let row">{{ row.dueDate }}</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>STATUS</th>
        <td mat-cell *matCellDef="let row">{{ row.status }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="open()"></tr>
    </table>
  </ng-container>
</div>
